// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3PYyS","label":"LabeledBox_label__DgYVB"};